import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({
  title = "Collegia — Academics Manager for University Students",
  description = "Collegia is the #1 academics manager trusted by 50,000+ students. Know how many lectures you can bunk and still maintain 75% attendance. Track attendance, view grades, manage timetables. Free on Android & iOS.",
  keywords = "Collegia, Collegia app, academics manager, attendance tracker, how many lectures can I bunk, 75 percent attendance calculator, bunk calculator, college attendance tracker, CUIMS, Chandigarh University, CU app, grade tracker, timetable app, student app, CUIMS alternative, attendance percentage calculator, minimum attendance, class bunk calculator",
  image = "/logo512.png",
  url = "https://collegia.app/",
  type = "website"
}) => {
  const fullTitle = title.includes("Collegia") ? title : `${title} | Collegia`;
  const fullImageUrl = image.startsWith('http') ? image : `https://collegia.app${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Collegia" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:alt" content="Collegia app" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:image:alt" content="Collegia app" />
    </Helmet>
  );
};

export default SEOHead;
